import React from 'react'
import PropTypes from 'prop-types'

import { DashboardChartPaper, DonutChart } from 'components'

import theme from 'theme'

const ComplaintByStatus = ({ complaints, id, ...rest }) => {
  const data = complaints?.reduce(
    (acc, complaint) => {
      if (complaint.status === 'pending') acc[0]++
      else if (complaint.status === 'finalized') acc[1]++
      else if (complaint.status === 'converted_incident') acc[2]++
      return acc
    },
    [0, 0, 0],
  )

  return (
    <DashboardChartPaper
      title="Denúncias por Status"
      subtitle="Pendente, Finalizado, Convertido em Incidente"
      heightContainer="fit-content"
      {...rest}
    >
      <DonutChart
        legendShow
        names={['Pendente', 'Finalizado', 'Convertido em Incidente']}
        values={data}
        title="Processos"
        colors={[
          theme.palette.dashboard.chart.primary.pending,
          theme.palette.dashboard.chart.primary.treated,
          theme.palette.dashboard.chart.primary.disapproved,
        ]}
        showName={false}
        id={id}
      />
    </DashboardChartPaper>
  )
}

ComplaintByStatus.propTypes = {
  complaints: PropTypes.array.isRequired,
}

export default ComplaintByStatus
